// Build-time version baked into the bundle. Compared at runtime against
// /version.json (which is regenerated on every deploy). Used to notify users
// running an outdated bundle.
const BUNDLED_VERSION = typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : 'dev';

const POLL_INTERVAL_MS = 5 * 60 * 1000; // 5 minutes
const VERSION_URL = '/version.json';

let listeners = [];
let started = false;
let lastSeenRemote = null;

async function fetchRemoteVersion() {
  try {
    const r = await fetch(`${VERSION_URL}?t=${Date.now()}`, {
      cache: 'no-store',
      headers: { 'Cache-Control': 'no-cache' },
    });
    if (!r.ok) return null;
    const data = await r.json();
    return typeof data?.version === 'string' ? data.version : null;
  } catch {
    return null;
  }
}

async function check() {
  const remote = await fetchRemoteVersion();
  if (!remote) return;
  if (remote === BUNDLED_VERSION) return;
  if (remote === lastSeenRemote) return; // already notified for this remote version
  lastSeenRemote = remote;
  listeners.forEach((cb) => {
    try {
      cb({ bundled: BUNDLED_VERSION, remote });
    } catch {}
  });
}

/**
 * Subscribe to "new version available" notifications.
 * Returns an unsubscribe function.
 */
export function onNewVersion(callback) {
  listeners.push(callback);
  return () => {
    listeners = listeners.filter((c) => c !== callback);
  };
}

/**
 * Start the polling loop. Safe to call multiple times — only the first call
 * actually starts the interval. Idempotent so React StrictMode double-invokes
 * don't create two pollers.
 */
export function startVersionCheck() {
  if (started) return;
  started = true;

  // Quick first check after the page has settled.
  setTimeout(check, 5000);

  // Poll periodically.
  setInterval(check, POLL_INTERVAL_MS);

  // Also re-check when the tab regains focus — catches users who left the tab
  // open overnight while a deploy happened.
  if (typeof document !== 'undefined') {
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') check();
    });
  }
}

/**
 * Hard reload — bypasses the HTTP cache to make sure the new bundle is fetched.
 * Adding a query string forces a different cache key.
 */
export function reloadForNewVersion() {
  const url = new URL(window.location.href);
  url.searchParams.set('v', Date.now().toString());
  window.location.replace(url.toString());
}
